import { useSwiper } from "swiper/react";
import { CarouselWoList } from "../models/ResponseModels/CarouselResponse";
import { useEffect, useState } from "react";
import { INITIAL_SLIDE } from "./CarouselHome";

export default function CustomPagination({ data }: { data: CarouselWoList[] }) {
  const swiper = useSwiper();

  const [page, setPage] = useState(INITIAL_SLIDE);
  const slideCount = data.length;

  useEffect(() => {
    if (!swiper) return;

    swiper.on("realIndexChange", (s) => {
      setPage(s.realIndex % slideCount);
    });
  }, [swiper, slideCount]);

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 10,
        left: 0,
        right: 0,
        bottom: 8,
        textAlign: "center",
      }}
    >
      {data.map((_, i) => {
        const isActive = i === page;

        return (
          <span
            key={"slide-pagination-" + i}
            onClick={!isActive ? () => swiper.slideToLoop(i) : undefined}
            style={{
              display: "inline-block",
              margin: "0 4px",
              width: 8,
              height: 8,
              borderRadius: "50%",
              cursor: "pointer",
              backgroundColor: isActive ? "#007aff" : "#000000",
              opacity: isActive ? 1 : 0.2,
            }}
          />
        );
      })}
    </div>
  );
}
